import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import { Home as HomeIcon } from "lucide-react";
import { CATEGORIES } from "@/constants/categories";

export default function CategoryBar() {
  const nav = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const active = params.get("category") || "";

  const select = (id) => {
    const next = location.pathname === "/villas" ? new URLSearchParams(params) : new URLSearchParams();
    if (id) next.set("category", id);
    else next.delete("category");
    nav(`/villas?${next.toString()}`);
  };

  const items = [{ id: "", label: "All villas", Icon: HomeIcon }, ...CATEGORIES];

  return (
    <Box
      data-testid="category-bar"
      sx={{
        position: "sticky",
        top: 80,
        zIndex: 40,
        bgcolor: "background.default",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Box
        className="no-scrollbar"
        sx={{
          display: "flex",
          gap: { xs: 3, md: 0 },
          justifyContent: { xs: "flex-start", md: "space-between" },
          overflowX: { xs: "auto", md: "visible" },
          maxWidth: 1400,
          mx: "auto",
          px: { xs: 3, lg: 6 },
        }}
      >
        {items.map(({ id, label, Icon }) => {
          const isActive = active === id;
          return (
            <Box
              key={label}
              component="button"
              type="button"
              onClick={() => select(id)}
              data-testid={`category-${id || "all"}`}
              sx={{
                flexShrink: 0,
                flex: { xs: "0 0 auto", md: 1 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.75,
                py: 1.25,
                px: 0.5,
                border: 0,
                borderBottom: 2,
                borderColor: isActive ? "text.primary" : "transparent",
                bgcolor: "transparent",
                cursor: "pointer",
                color: isActive ? "text.primary" : "text.secondary",
                opacity: isActive ? 1 : 0.75,
                transition: "opacity 0.2s, border-color 0.2s",
                "&:hover": { opacity: 1, color: "text.primary" },
              }}
            >
              <Icon size={21} strokeWidth={isActive ? 2.1 : 1.6} />
              <Box sx={{ fontSize: 12.5, fontWeight: isActive ? 600 : 500, whiteSpace: "nowrap" }}>{label}</Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
